import { render, staticRenderFns } from "./scanStat.vue?vue&type=template&id=365fa7ac&scoped=true"
import script from "./scanStat.vue?vue&type=script&lang=js"
export * from "./scanStat.vue?vue&type=script&lang=js"
import style0 from "./scanStat.vue?vue&type=style&index=0&id=365fa7ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fa7ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365fa7ac')) {
      api.createRecord('365fa7ac', component.options)
    } else {
      api.reload('365fa7ac', component.options)
    }
    module.hot.accept("./scanStat.vue?vue&type=template&id=365fa7ac&scoped=true", function () {
      api.rerender('365fa7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/scanStat.vue"
export default component.exports